import React from "react";
// import { Link } from "gatsby";
import SideBarTitleItem from "./SideBarTitleItem";
import blogImage1 from "../../images/hgf.png";
import blogImage2 from "../../images/jfm.png";
import blogImage3 from "../../images/jfd.png";
import blogImage4 from "../../images/jfp.png";
import blogImage5 from "../../images/jff.png";
import blogImage6 from "../../images/jfs.png";
import blogImage7 from "../../images/rpp.png";
import blogImage8 from "../../images/jfj.png";
import blogImage9 from "../../images/jfk.png";
import blogImage10 from "../../images/jfr.png";

const blogContent1 = {
    "Title": "HGF",
    "TitleLink": "/titles/hgf-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "HENRY GIESSENBIER FELLOW",
    "ImagePath": blogImage1,
    "Amount": "3,000",
};

const blogContent2 = {
    "Title": "JFM",
    "TitleLink": "/titles/jfm-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION MEMBER",
    "ImagePath": blogImage2,
    "Amount": "5,000",
};

const blogContent3 = {
    "Title": "JFD",
    "TitleLink": "/titles/jfd-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION DONOR",
    "ImagePath": blogImage3,
    "Amount": "10,000",
};

const blogContent4 = {
    "Title": "JFA",
    "TitleLink": "/titles/jfa-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "Jaycee Foundation Achiever",
    "ImagePath": blogImage3,
    "Amount": "15,000",
};

const blogContent5 = {
    "Title": "JFP",
    "TitleLink": "/titles/jfp-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION PATRON",
    "ImagePath": blogImage4,
    "Amount": "25,000",
};

const blogContent6 = {
    "Title": "JFF",
    "TitleLink": "/titles/jff-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION FELLOW",
    "ImagePath": blogImage5,
    "Amount": "50,000",
};

const blogContent7 = {
    "Title": "JFS",
    "TitleLink": "/titles/jfs-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION STAR",
    "ImagePath": blogImage6,
    "Amount": "1,00,000",
};

const blogContent8 = {
    "Title": "JFG",
    "TitleLink": "/titles/jfg-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "Jaycee Foundation Gem",
    "ImagePath": blogImage6,
    "Amount": "2,00,000",
};

const blogContent9 = {
    "Title": "RPP",
    "TitleLink": "/titles/rpp-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "RAJENDRANATH PAI PATRON",
    "ImagePath": blogImage7,
    "Amount": "3,00,000",
};

const blogContent10 = {
    "Title": "JFJ",
    "TitleLink": "/titles/jfj-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION JEWEL",
    "ImagePath": blogImage8,
    "Amount": "5,00,000",
};

const blogContent11 = {
    "Title": "JFK",
    "TitleLink": "/titles/jfk-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION KOHINOOR",
    "ImagePath": blogImage9,
    "Amount": "10,00,000",
};

const blogContent12 = {
    "Title": "JFR",
    "TitleLink": "/titles/jfr-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION RATNA",
    "ImagePath": blogImage10,
    "Amount": "4,00,000",
};

const blogContent13 = {
    "Title": "JFE",
    "TitleLink": "/titles/jfe-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION EMERALD",
    "ImagePath": blogImage9,
    "Amount": "7,50,000",
};

const blogContent14 = {
    "Title": "JFI",
    "TitleLink": "/titles/jfi-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION ICON",
    "ImagePath": blogImage9,
    "Amount": "25,00,000",
};

const blogContent15 = {
    "Title": "JFC",
    "TitleLink": "/titles/jfc-title",
    "DonateButtonText": "Read More",
    "DonateButtonLink": "#none",
    "Description": "JAYCEE FOUNDATION CROWN",
    "ImagePath": blogImage9,
    "Amount": "75,00,000",
};

const TitleSidebar = props => {
    return (
        <div className="side-widget">
            <h2 className="widget__title">Other Honours</h2>
            <SideBarTitleItem blogContent={blogContent1} />
            <SideBarTitleItem blogContent={blogContent2} />
            <SideBarTitleItem blogContent={blogContent3} />
            <SideBarTitleItem blogContent={blogContent4} />
            <SideBarTitleItem blogContent={blogContent5} />
            <SideBarTitleItem blogContent={blogContent6} />
            <SideBarTitleItem blogContent={blogContent7} />
            <SideBarTitleItem blogContent={blogContent8} />
            <SideBarTitleItem blogContent={blogContent9} />
            <SideBarTitleItem blogContent={blogContent12} />
            <SideBarTitleItem blogContent={blogContent10} />
            <SideBarTitleItem blogContent={blogContent13} />
            <SideBarTitleItem blogContent={blogContent11} />
            <SideBarTitleItem blogContent={blogContent14} />
            <SideBarTitleItem blogContent={blogContent15} />
        </div>
    );
};

export default TitleSidebar;
